import { render, staticRenderFns } from "./OrderHistoryDesignDetail.vue?vue&type=template&id=999657ba&scoped=true"
import script from "./OrderHistoryDesignDetail.vue?vue&type=script&lang=js"
export * from "./OrderHistoryDesignDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryDesignDetail.vue?vue&type=style&index=0&id=999657ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999657ba",
  null
  
)

export default component.exports